import type { ReactNode } from "react";

/** Static stories can pass text; activity definitions defer messages until their slides render. */
export type SlideText = string | (() => string);
export type SlideQuestion = ReactNode | SlideText;

export function resolveText(text: SlideText): string {
  return typeof text === "function" ? text() : text;
}

export function resolveQuestion(question: SlideQuestion): ReactNode {
  return typeof question === "function" ? question() : question;
}
